import { noticeError } from './';

function isReactDeprecationWarning(message: any): boolean {
  if (typeof message !== 'string') {
    return false;
  }
  // Common patterns for React deprecation
  const patterns = [
    /deprecated/i,
    /will be removed/i,
    /no longer supported/i,
    /has been removed/i,
    /is no longer recommended/i,
  ];
  // Optionally, check for "Warning:" prefix
  if (!message.startsWith('Warning')) {
    return false;
  }
  return patterns.some(pattern => pattern.test(message));
}

// Save original methods
const originalWarn = console.warn;
const originalError = console.error;

export function setReactUpgradeMonitoring() {
  console.warn = function(...args) {
    // Check for React deprecation warning pattern
    if (isReactDeprecationWarning(args[0])) {
      // Send to New Relic
      noticeError(new Error(...args), { type: 'React Warning' });
    }
    originalWarn.apply(console, args);
  };

  console.error = function(...args) {
    // Optionally filter for React errors
    if (isReactDeprecationWarning(args[0])) {
      noticeError(new Error(...args), { type: 'React Error' });
    }
    originalError.apply(console, args);
  };
}
